import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { KEY_ACCESS_TOKEN, KEY_AZURE_TOKEN, KEY_CONFIG_URL, KEY_REFRESH_TOKEN, REFRESH_URL, X_API_KEY } from '../Helpers/constant';
import { LoginData } from '../interfaces/Auth';
import { PaymentData } from '../interfaces/Common';
import { EventFormValues, RegisterEvent } from '../interfaces/Events';
import { postComplaintPayload } from '../interfaces/Survey';
import { ProfileDetailsFormValues } from '../interfaces/Profile';
import { GetinTouch } from '../interfaces/Portfolio';

let appConfig: { apiBaseUrl: string; tokenUrl: string } | undefined;
export let axiosInstance: AxiosInstance;
const configUrl = KEY_CONFIG_URL;
const turbosendURL = 'https://turbosend-impl-dev-ken-api.turboverse.co';
export const getAxiosInstance = (data: { config?: { apiBaseUrl: string; tokenUrl: string } }[]) => {
  appConfig = data[0]?.config;
  axiosInstance = axios.create({
    // baseURL: 'http://localhost:4000',
    baseURL: 'https://ideabaaz-jury-api.turboverse.co/',
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req: AxiosRequestConfig): any => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers = req.headers || {};
    // req.headers['x-api-key'] = X_API_KEY;
    req.headers['Authorization'] = `${token}`;

    return req;
  });

  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      if (error.response?.status !== 401) {
        return Promise.reject(error);
      }

      // Handle 401 Unauthorized error
      if (error.response.status === 401) {
        try {
          const refreshToken = localStorage.getItem(KEY_REFRESH_TOKEN);
          const azureToken = localStorage.getItem(KEY_AZURE_TOKEN);

          if (!refreshToken) {
            localStorage.clear();
            window.location.reload();
          }

          const res = await axios.post(
            REFRESH_URL,
            { refreshToken },
            {
              headers: {
                Authorization: `Bearer ${azureToken}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          );

          const { accessToken, refreshToken: newRefreshToken } = res.data;

          localStorage.setItem(KEY_ACCESS_TOKEN, accessToken.token);
          localStorage.setItem(KEY_REFRESH_TOKEN, newRefreshToken.token);

          // Update the original request with the new access token
          error.config.headers['Authorization'] = `Bearer ${accessToken.token}`;
          error.config.headers['access-token'] = accessToken.token;

          // Retry the original request with the new token
          return axios(error.config);
        } catch (err) {
          console.error('Token refresh failed:', err);
          localStorage.clear();
          window.location.reload();
          return Promise.reject(err);
        }
      }

      return Promise.reject(error);
    }
  );
};

export const getConfig = async () => {
  try {
    const configKey = '664c2d35a926bb001ae67409';
    const res = await axios.get(`${configUrl}/${configKey}`);
    return res && res.data ? res.data : null;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getOtp = async (email: string) => {
  try {
    // const path = `/v1/auth/send/otp?email=${email}&update=${reset}`;
    const path = `/v1/auth/send/otp?email=${email}`;
    const res = await axiosInstance.post(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      return error;
    }
  }
};

export const verifyOtp = async (email: string, otp: string) => {
  try {
    const path = `/v1/auth/verify/otp?email=${email}&otp=${otp}`;
    const res = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const verifyOtpReset = async (email: string, otp: string) => {
  try {
    const path = `/v1/auth/verify/otpwithContact?email=${email}&otp=${otp}`;
    const res = await axiosInstance.post(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const loginSSO = async (email: string) => {
  try {
    const path = `/v1/auth/sso/user/verify?email=${email}`;
    const response = axiosInstance.get(path);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const authLogin = async (data: LoginData) => {
  try {
    const path = `/v1/auth/login/verify`;
    const res: any = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const resetPassword = async (data: LoginData) => {
  try {
    const path = `/v1/auth/login/reset`;
    const res: any = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};
export const getEvents = async (contactId: string) => {
  try {
    const path = `/v1/event/fetch/user/events?contactId=${contactId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getEvent = async (id: string) => {
  try {
    const path = `/v1/event/fetch/event/ById?eventId=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getFileUrl = async (data: File) => {
  try {
    const path = `/v1/event/create/publicUrl`;
    const form = new FormData();
    form.append('file', data);
    const res: any = await axiosInstance.post(path, form);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

// Home
export const getInvestorFund = async (id: any) => {
  try {
    const path = `v1/people/get_investor_fund?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getAllInvestorFund = async (id: any) => {
  try {
    const path = `v1/people/get_all_investor_funds?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getInstallmentBankinfo = async (id: any) => {
  try {
    const path = `v1/portfolio/get_installment_bankinfo?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const postCreatePaymentTransactions = async (payload: any) => {
  try {
    const path = `v1/portfolio/create_payment_transcation`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getTransactionDetails = async (id: any) => {
  try {
    const path = `v1/portfolio/get_transcation_details?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getSpotlight = async () => {
  try {
    const path = `v1/profile/get/spotlight`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

// profile

export const getProfile = async (id: string) => {
  try {
    const path = `v1/profile/get/account/info?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};
export const postEditProfile = async (payload: ProfileDetailsFormValues) => {
  try {
    const path = `/v1/profile/update/account/info`;
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

// events
export const hostEvent = async (payload: EventFormValues) => {
  try {
    const path = `/v1/event/create/event/schedule`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const registerEvent = async (payload: RegisterEvent) => {
  try {
    const path = `/v1/event/new/registration`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const eventPayment = async (payload: PaymentData) => {
  try {
    const path = `/v1/payment/generate/payment`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const cancelEvent = async (id: string) => {
  try {
    const path = `/v1/event/cancel/registration?eventRegistrationId=${id}`;
    const res: any = await axiosInstance.delete(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getOptions = async (objectName: string, fieldName: string) => {
  try {
    const path = `/v1/helper/getDropDownValues?objectName=${objectName}&fieldName=${fieldName}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};
export const getFaq = async () => {
  try {
    const path = `/v1/support/get/faq`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getTicketHistory = async (accountId: string) => {
  try {
    const path = `/v1/support/get/user/case?userId=${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const cancelService = async (id: string) => {
  try {
    const path = `/v1/support/delete/case?caseId=${id}`;
    const res: any = await axiosInstance.patch(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const postComplaint = async (payload: postComplaintPayload) => {
  try {
    const path = `/v1/support/post/case`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getJobFavorite = async (accountId: string) => {
  try {
    const path = `/v1/favourite/get/user/favorite?accountId=${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

// people
export const getInvestors = async () => {
  try {
    const path = `/v1/people/get/investors`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getTeam = async () => {
  try {
    const path = `/v1/people/get/Employee`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getInvestorsById = async (id: string) => {
  try {
    const path = `/v1/people/get_startup_mentor?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};
export const getTeamById = async (id: string) => {
  try {
    const path = `/v1/people/get_team_involvement?contactId=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

// COE
export const getCOE = async () => {
  try {
    const path = `/v1/people/get/coe`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getCOEOfferings = async (id: string) => {
  try {
    const path = `v1/people/get/coe/offering/ById?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

// my portfolio
export const getPortfolio = async (id: any) => {
  try {
    const path = `v1/portfolio/get/portfolio?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getFundReport = async (id: any) => {
  try {
    const path = `v1/portfolio/get_fund_report?accountId=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getPortfolioTeam = async (id: string) => {
  try {
    const path = `v1/portfolio/get/team?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getPortfolioKeyCustomers = async (id: string) => {
  try {
    const path = `v1/portfolio/get/client?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const postGetinTouch = async (payload: GetinTouch) => {
  try {
    const path = `/v1/people/create_interset`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getCoeImpact = async (id: string) => {
  try {
    const path = `v1/portfolio/get_startup_coes?id=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

// startups
export const getStartups = async (id: any) => {
  try {
    const path = `v1/portfolio/get/startups?accountId=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getFundDetails = async (fundId: string) => {
  try {
    const path = `v1/portfolio/get_fund_stage?id=${fundId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getValuationRevenue = async (startupId: string) => {
  try {
    const path = `v1/portfolio/get_valutaion/get_revenue?id=${startupId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

// Jury Portal
export const getEvaluationMeeting = async (contactId: string) => {
  try {
    const path = `/v1/jury/evaluation/meeting?contactid=${contactId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const getEvaluationFeedback = async (contactId: string, applicationid: string) => {
  try {
    const path = `/v1/jury/evaluation/feedbacks?contactid=${contactId}&applicationid=${applicationid}&round=Shortlisted`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Handle Axios-specific errors
      return error.response?.data ? error.response.data : error;
    } else {
      // Handle other types of errors
      return error;
    }
  }
};

export const postFeedback = async (payload: any) => {
  const path = `/v1/jury/evaluation/save`;
  const res: any = await axiosInstance.post(path, payload);
  return res;
};

//Chat APIs

export const registerUser = async (payload: any) => {
  try {
    const path = `${turbosendURL}/api/users/create`;
    const res = await axios.post(path, payload);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const createChatRoom = async (payload: any) => {
  try {
    const path = `${turbosendURL}/api/chatrooms/create`;
    const res = await axios.post(path, payload);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getChatRoom = async (Id: any) => {
  try {
    const path = `${turbosendURL}/api/chatrooms/userId?userId=${Id}`;
    const res = await axios.get(path);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getCommonChatRoom = async (Id1: any, Id2: any) => {
  try {
    const path = `${turbosendURL}/api/chatrooms/commonChatRooms?userId1=${Id1}&userId2=${Id2}`;
    const res = await axios.get(path);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const GetRecentMessages = async (Id: any, currentPage: any, perPage: any) => {
  try {
    const path = `${turbosendURL}/api/chatrooms/get/recent-messages/${Id}`;
    const res = await axios.get(path, {
      params: {
        currentPage,
        perPage,
      },
    });
    // const res = await axios.get(path);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const TurboSendFileUpload = async (data: any) => {
  try {
    const path = `${turbosendURL}/api/uploadFile`;
    const res = await axios.post(path, data);
    return res;
  } catch (err) {
    console.log(err);
  }
};
